import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { canEditPetition, Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'edit-petition-update',
		path: '/p/:slug/u/:updateId/edit',
		component: loadable(async () => import(/* webpackChunkName: "pages/petition-update-edit" */ './index'), {
			exportName: 'EditPetitionUpdateView',
			fallback: Loading,
		}),
		frame: true,
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support', canEditPetition('slug')],
		},
		ssr: {
			enabled: false,
			seo: false,
		},
	},
];
